import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { FiX } from "react-icons/fi";
import { motion } from "framer-motion";
import RecoverySymptomsCard from "../../components/RecoverySymptomsCard";
import { useLessons } from "../../hooks/useLessons"; // Import the hook for filtering

export default function SymptomsCheckin() {
  const navigate = useNavigate();
  const location = useLocation();
  const { birthType } = useLessons(); // Get the birth type (vaginal or csection)

  const selectedWeek: number =
    (location.state as { week?: number; dateId?: string })?.week ?? 1;
  const dateId = (location.state as { week?: number; dateId?: string })?.dateId;

  const fromDashboard = (location.state as { from?: string })?.from === "dashboard";

  const handleClose = () => {
    if (fromDashboard) {
      navigate("/dashboard");
    } else {
      navigate("/recovery", { state: { week: selectedWeek } });
    }
  };

  return (
    <div className="fixed inset-0 z-[200]">
      <motion.button
        type="button"
        aria-label="Close"
        onClick={handleClose}
        className="absolute inset-0 bg-black/30 backdrop-blur-[2px]"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.2 }}
      />

      <motion.div
        className="absolute bottom-0 left-0 right-0 mx-auto w-full max-w-[430px]"
        initial={{ y: "100%" }}
        animate={{ y: 0 }}
        transition={{ type: "spring", stiffness: 340, damping: 32, mass: 0.9 }}
      >
        <article className="relative bg-[#fcf9f7] rounded-t-[32px] px-6 pt-6 pb-10 shadow-2xl max-h-[85vh] overflow-y-auto">
          <div className="mx-auto mb-4 h-1.5 w-12 rounded-full bg-black/10" />

          <button
            type="button"
            onClick={handleClose}
            aria-label="Close"
            className="absolute top-5 right-5 border-none bg-white/70 backdrop-blur inline-flex items-center justify-center w-9 h-9 rounded-full hover:bg-white transition-colors"
          >
            <FiX size={20} />
          </button>

          {/* ── Header with Context (Tester Recommendation) ── */}
          <header className="mb-6">
            <h2 className="m-0 font-semibold text-2xl text-[#0c2624] leading-tight">
              Log your symptoms
            </h2>
            <p className="m-0 mt-2 text-sm text-gray-500 font-dm-sans leading-relaxed">
              This helps you notice patterns and understand your recovery journey over time.
            </p>
          </header>

          <div>
            <RecoverySymptomsCard
              weekNumberOverride={selectedWeek}
              dateIdOverride={dateId}
              onSaveSuccess={handleClose}
              // Pass birthType to the card so it can filter the questions
              birthType={birthType} 
            />
          </div>
        </article>
      </motion.div>
    </div>
  );
}